"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "nav-top" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "name" };
const _hoisted_5 = { class: "nav-items" };
const _hoisted_6 = { class: "nav-link" };
const _hoisted_7 = { class: "nav-link-inner" };
const _hoisted_8 = { class: "nav-link-icon" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "nav-text" };
const _hoisted_11 = { class: "nav-link" };
const _hoisted_12 = { class: "nav-link-inner" };
const _hoisted_13 = { class: "nav-link-icon" };
const _hoisted_14 = ["src"];
const _hoisted_15 = { class: "nav-text" };
const _hoisted_16 = {
    key: 0,
    class: "nav-link"
};
const _hoisted_17 = { class: "nav-link-inner" };
const _hoisted_18 = { class: "nav-link-icon" };
const _hoisted_19 = ["src"];
const _hoisted_20 = { class: "nav-text" };
const _hoisted_21 = {
    key: 1,
    class: "nav-link"
};
const _hoisted_22 = { class: "nav-link-inner" };
const _hoisted_23 = { class: "nav-link-icon" };
const _hoisted_24 = { class: "nav-text" };
const _hoisted_25 = { class: "nav-link" };
const _hoisted_26 = { class: "nav-link-inner" };
const _hoisted_27 = { class: "nav-link-icon" };
const _hoisted_28 = { class: "nav-text" };
const _hoisted_29 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "nav-link" }, null, -1);
const vue_3 = require("vue");
const toastStore_1 = require("../../../stores/toast/toastStore");
const securityStore_1 = require("../../../stores/security/securityStore");
const vue_router_1 = require("vue-router");
const CompanyLocationStore_1 = require("../../../stores/backend/company/CompanyLocationStore");
const PermissionEnum_1 = require("../../../stores/permission/PermissionEnum");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Navbar',
    setup(__props) {
        const companyLocationStore = (0, CompanyLocationStore_1.useCompanyLocationStore)();
        //import LocaleSwitcher from "../LocaleSwitcher.vue";
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const router = (0, vue_router_1.useRouter)();
        const onLogout = (e) => {
            e.preventDefault();
            securityStore.logout(router).catch((error) => {
                toastStore.addFadingErrorToast(error.toString());
            });
        };
        let navClosed = (0, vue_3.ref)(false);
        //let dropDown: Ref<boolean> = ref(false);
        function navbarWidth() {
            if (navClosed.value === false) {
                navClosed.value = true;
            }
            else {
                navClosed.value = false;
            }
        }
        /*
        function dropDownMenu() {
          if (dropDown.value === false) {
            dropDown.value = true;
          } else {
            dropDown.value = false;
          }
        }*/
        return (_ctx, _cache) => {
            var _a;
            const _component_router_link = (0, vue_2.resolveComponent)("router-link");
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("nav", {
                class: (0, vue_2.normalizeClass)(["navbar", { closed: (0, vue_2.unref)(navClosed) }])
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(_component_router_link, {
                        to: { name: 'dashboard' },
                        class: "logo"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("img", {
                                src: require(`../../../images/backend/marsoNavLogo.svg`),
                                alt: "Marsó logó",
                                class: "open"
                            }, null, 8, _hoisted_2),
                            (0, vue_2.createElementVNode)("img", {
                                src: require(`../../../images/backend/marsoNavLogoClosed.svg`),
                                alt: "Marsó logó",
                                class: "closed"
                            }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createElementVNode)("span", {
                        class: "arrow",
                        onClick: _cache[0] || (_cache[0] = ($event) => (navbarWidth()))
                    }, [
                        (0, vue_2.createVNode)(_component_font_awesome_icon, { icon: ['fa', 'angles-left'] })
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((_a = (0, vue_2.unref)(companyLocationStore).selectedLocation) === null || _a === void 0 ? void 0 : _a.name), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createVNode)(_component_router_link, { to: { name: 'reservations_calendar_view' } }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", _hoisted_7, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                        (0, vue_2.createElementVNode)("img", {
                                            src: require(`../../../images/backend/navbar-icons/calendar.svg`),
                                            alt: "Foglalások"
                                        }, null, 8, _hoisted_9)
                                    ]),
                                    (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)(_ctx.$trans("calendar_view", "Calendar View", "navbar")), 1)
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                        (0, vue_2.createVNode)(_component_router_link, { to: { name: 'dashboard' } }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", _hoisted_12, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                        (0, vue_2.createElementVNode)("img", {
                                            src: require(`../../../images/backend/navbar-icons/reservations.png`),
                                            alt: "Foglalások"
                                        }, null, 8, _hoisted_14)
                                    ]),
                                    (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)(_ctx.$trans("bookings", "Bookings", "navbar")), 1)
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    ((0, vue_2.unref)(securityStore).authenticatedUser !== null &&
                        (0, vue_2.unref)(securityStore).authenticatedUser.hasPermission((0, vue_2.unref)(PermissionEnum_1.ServicePermissionEnum).SERVICE_WRITE))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                            (0, vue_2.createVNode)(_component_router_link, { to: { name: 'services' } }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", _hoisted_17, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                            (0, vue_2.createElementVNode)("img", {
                                                src: require(`../../../images/backend/navbar-icons/services.png`),
                                                alt: "Szolgáltatások"
                                            }, null, 8, _hoisted_19)
                                        ]),
                                        (0, vue_2.createElementVNode)("span", _hoisted_20, (0, vue_2.toDisplayString)(_ctx.$trans("services", "Services", "navbar")), 1)
                                    ])
                                ]),
                                _: 1
                            })
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(securityStore).authenticatedUser !== null &&
                        (0, vue_2.unref)(securityStore).authenticatedUser.hasPermission((0, vue_2.unref)(PermissionEnum_1.OffDayPermissionEnum).OFFDAY_WRITE))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, [
                            (0, vue_2.createVNode)(_component_router_link, { to: { name: 'excluded_days' } }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", _hoisted_22, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                            (0, vue_2.createVNode)(_component_font_awesome_icon, { icon: ['fa', 'calendar-xmark'] })
                                        ]),
                                        (0, vue_2.createElementVNode)("span", _hoisted_24, (0, vue_2.toDisplayString)(_ctx.$trans("excluded_days", "Excluded days", "navbar")), 1)
                                    ])
                                ]),
                                _: 1
                            })
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_25, [
                        (0, vue_2.createVNode)(_component_router_link, {
                            to: "/",
                            onClick: onLogout
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", _hoisted_26, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                        (0, vue_2.createVNode)(_component_font_awesome_icon, { icon: ['fas', 'right-from-bracket'] })
                                    ]),
                                    (0, vue_2.createElementVNode)("span", _hoisted_28, (0, vue_2.toDisplayString)(_ctx.$trans("logout", "Logout", "navbar")), 1)
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _hoisted_29
                ])
            ], 2));
        };
    }
});
